module.exports = __webpack_public_path__ + "assets/images/electoral-college/map/mobile.svg?v=86acc0d8";